<template lang="pug">
.druck-vorlage--preview(:style="`min-width: ${minWidth}mm`" @click="clickOutside" :class="`${showBorder ? 'druck-vorlage--border' : 'druck-vorlage--noborder'} druck-vorlage--opacity-${bgOpacity} ${item ? '' : 'druck-vorlage--preview-template'}`")
  .print-page-alert: v-alert(:value="!!error" type="error") {{error}}
  div(ref="pages" :style="{ color: color }")
    template(v-for="page, pageI in pages")
      extra-druck-vorlagen-page(:bg="showBg" :value="page" @click-page="clickPage" @click-text="clickText" :class="pageI === currentPage ? `druck-vorlage__page--current` : ''")
        template(v-slot:page-pre v-if="!item")
          v-menu(open-on-hover z-index="900")
            v-btn(slot="activator" icon fab absolute top small outline color="grey" style="left: -50px"): v-icon more_vert
            v-list
              v-list-tile(@click="addText(page)")
                v-list-tile-avatar: v-icon add
                v-list-tile-title Text Hinzufügen
              v-list-tile
                v-list-tile-avatar: v-btn(@click="movePageDown(page)" :disabled="pageI + 1 === value.pages.length" icon): v-icon arrow_downward
                v-list-tile-avatar: v-btn(@click="movePageUp(page)" :disabled="pageI === 0" icon): v-icon arrow_upward
                v-list-tile-title Seite Bewegen
              v-list-tile: radio-group(row label="Format" v-model="page.format" :items="pageSizes" @change="changeFormat($event, page)")
              v-list-tile: v-checkbox(label="Querformat" :input-value="page.width > page.height" @change="changeLandscape($event, page)")
              v-list-tile
                file-input(label="Hintergrund" v-model="page.backgroundName" base64 @base64="changeBackground($event, page)")
                v-btn(icon @click="removeBackground(page)"): v-icon delete
              v-list-tile(@click="deletePage(page)")
                v-list-tile-avatar: v-icon delete
                v-list-tile-title Seite Löschen
        template(v-slot:text="{ text }")
          .druck-vorlage__page__text__wrap(ref="textWraps" :class="resizing === text ? 'druck-vorlage__page__text__wrap--current' : ''")
            .druck-vorlage-multi-text(v-if="pageI == 0 && text.options.indexOf('multiple-text') >= 0")
            template(v-if="resizing === text")
              template(v-if="!item")
                .druck-vorlage__page__text__inner.druck-vorlage__page__text__inner--left(@keydown.up.down.left.right="keyText($event, page, text, 'left')" @keydown.delete="removeText(page, text)" tabindex="-1" ref="left")
                .druck-vorlage__page__text__inner.druck-vorlage__page__text__inner--right(@keydown.up.down.left.right="keyText($event, page, text, 'right')" @keydown.delete="removeText(page, text)" tabindex="-1" ref="right")
                .druck-vorlage__page__text__inner.druck-vorlage__page__text__inner--top(@keydown.up.down.left.right="keyText($event, page, text, 'up')" @keydown.delete="removeText(page, text)" tabindex="-1" ref="up")
                .druck-vorlage__page__text__inner.druck-vorlage__page__text__inner--bottom(@keydown.up.down.left.right="keyText($event, page, text, 'down')" @keydown.delete="removeText(page, text)" tabindex="-1" ref="down")
                .druck-vorlage__page__text__inner.druck-vorlage__page__text__inner--move(@keydown.up.down.left.right="keyText($event, page, text, 'move')" @keydown.delete="removeText(page, text)" tabindex="-1" ref="move")
                .druck-vorlage__page__text__inner.druck-vorlage__page__text__inner--info(v-if="showInfo")
                  | x = {{text.x}}
                  | y = {{text.y}}
                  | w = {{text.width}}
                  | h = {{text.height}}
                  | s = {{text.size}}
                  | l = {{text.lineHeight}}
                  | o = {{text.options}}
                textarea.druck-vorlage__edittemplate(v-model="text.template")
              template(v-else)
                trix-editor(
                  class="trix-content"
                  ref="trix"
                  input="trixi"
                  toolbar="edit-toolbar"
                  placeholder=""
                  @trix-initialize="trixInitialize($event, pageI)"
                  @trix-change="trixChange($event, text)"
                )
            template(v-else-if="item")
              div(v-html="text.text")
            template(v-else)
              div(v-html="text.template")

  input(type="hidden" ref="trixi" id="trixi" :value="editorContent")
  trix-toolbar.trix-toolbar-wrapper(id="edit-toolbar" v-show="!noEditor && (resizing || item)" @click.stop)
    v-card.elevation-15
      v-card-text.pa-1
        template(v-if="item && resizing")
          v-btn.trix-disableable(data-trix-attribute='bold' data-trix-key='b' title='bold' tabindex='-1' icon): v-icon format_bold
          br
          v-btn.trix-disableable(data-trix-attribute='italic' data-trix-key='i' title='italic' tabindex='-1' icon): v-icon format_italic
          br
          v-btn.trix-disableable(data-trix-attribute='strike' data-trix-key='s' title='strike' tabindex='-1' icon): v-icon format_strikethrough
          br
          v-btn.trix-disableable(data-trix-attribute='bullet' title='bullets' tabindex='-1' icon): v-icon format_list_bulleted
          v-divider
        template(v-if="resizing")
          v-btn(icon @click="align('left')" :input-value="resizing.options.indexOf('align-left') >= 0"): v-icon format_align_left
          br
          v-btn(icon @click="align('right')" :input-value="resizing.options.indexOf('align-right') >= 0"): v-icon format_align_right
          br
          v-btn(icon @click="align('center')" :input-value="resizing.options.indexOf('align-center') >= 0"): v-icon format_align_center
          br
          v-btn(icon @click="align('justify')" :input-value="resizing.options.indexOf('align-justify') >= 0"): v-icon format_align_justify
          br
          v-btn(icon @click="textOption('multiple-text')" :input-value="resizing.options.indexOf('multiple-text') >= 0"): v-icon subtitles
          br
          template(v-if="item && resizing.options.indexOf('multiple-text') >= 0")
            v-btn(icon @click="splitMultitext"): v-icon drag_handle
            br
        v-btn(icon @click="resizeTexts"): v-icon format_size
        template(v-if="resizing")
          br
          v-btn(icon @click="resizeBigger"): v-icon add
          br
          v-btn(icon @click="resizeSmaller"): v-icon remove
          template(v-if="!item && resizing")
            br
            v-btn(icon @click="removeText(resizePage, resizing)"): v-icon delete
        div(v-show="false")
          v-btn.trix-disableable(data-trix-action='undo' data-trix-key='z' title='undo' tabindex='-1' icon): v-icon undo
          v-btn.trix-disableable(data-trix-action='redo' data-trix-key='shift+z' title='redo' tabindex='-1' icon): v-icon redo
  v-card.mt-5
    v-list
      template(v-for="(patientenverfuegungPdf, index) in patientenverfuegungPdfs")
        v-list-tile(v-if="patientenverfuegungPdf.druckvorlagenName === druckvorlagenName")
          a(:href="patientenverfuegungPdf.pdfUrl") {{druckvorlagenName}} vom {{formatDate(patientenverfuegungPdf.createdAt)}}
          v-btn(@click="showOldText(patientenverfuegungPdf)") Zeige alten Text
          v-btn(v-if="daysBetween(patientenverfuegungPdf.createdAt) <= 7" @click="pdfDestroy(patientenverfuegungPdf.id)") Lösche die PDF


</template>

<style lang="stylus">
:root {
  --druck-vorlage-multi-text-top: 0;
  --druck-vorlage-multi-text-height: 0;
}
.druck-vorlage__edittemplate {
  height 100%
  width 100%
  display block
  background-color rgba(255,255,255, 0.9)
  margin-right -15px
}
.print-page-alert {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
.druck-vorlage--preview {
  padding-left 55px
  padding-right 40px
  box-sizing content-box
}
.druck-vorlage__page__text__wrap {
  height 100%
}
.druck-vorlage--preview-template .druck-vorlage__page__text__wrap {
  overflow hidden
}
.druck-vorlage--preview-template .druck-vorlage__page__text__wrap--current {
  overflow visible
}
.druck-vorlage__page__text__inner {
  border 1px solid black
  position absolute
  height 100%
  width 100%
  opacity 0.5
  z-index 3
  &:focus {
    outline none
    border-style double
    border-width 3px
  }
}
.druck-vorlage__page__text__inner--info {
  border-width 0
  white-space pre
  bottom calc(-5em - 20px)
  height 5em
  opacity 1
  font-size 3mm
  pointer-events none
}
.druck-vorlage__page__text__inner--move {
  border-style none !important
  cursor grab
  height 0
}
.druck-vorlage__page__text__inner--left {
  border-right-width: 0 !important;
  width: 20px
  left: -20px
  cursor col-resize
}
.druck-vorlage__page__text__inner--right {
  border-left-width: 0 !important;
  width 20px
  right -20px
  cursor col-resize
}
.druck-vorlage__page__text__inner--top {
  border-bottom-width: 0 !important;
  height 20px
  top -20px
  cursor row-resize
}
.druck-vorlage__page__text__inner--bottom {
  border-top-width: 0 !important;
  height 20px
  bottom -20px
  cursor row-resize
}
.druck-vorlage--preview .trix-toolbar-wrapper {

}
trix-editor {
  min-height 100%
}
.druck-vorlage--border trix-editor {
  background-color: rgba(255,255,255, 0.9)
  margin-bottom: 20px;
}

.container {
  width: 100%;
  padding: 15px 0;
}
.editor-wrapper,
.form-wrapper {
  max-width: 700px;
}
input,
button {
  margin: 10px 0;
  font-size: 15px;
}
input[type="text"] {
  width: 100%;
  padding: 10px 0;
}
button {
  min-width: 120px;
}
.trix-toolbar-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.trix-button-group {
  margin-bottom: 0;
}
.trix-active.trix-active.trix-active {
  background-color: rgba(25,118,210, 0.6);
}
.trix-disableable.trix-disableable[disabled] {
  color: #ccc;
}
.text strong {
  font-size: inherit;
}
</style>
<script>
import gql from 'graphql-tag'
import Vue from 'vue'
Vue.config.ignoredElements.push('trix-editor')
Vue.config.ignoredElements.push('trix-toolbar')
import moment from 'moment'
import { maxBy } from 'lodash'
import ExtraDruckVorlagenPage from "./extra-druck-vorlagen-page.vue"
import 'trix'
import Liquid from 'liquidjs'
import { printPdfFor, druckOptionenFor } from "./extra-druck-vorlagen-settings.vue"

const engine = new Liquid();
const unescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&#34;': '"',
  '&#39;': "'"
}
engine.registerFilter('html', str => {
  return String(str).replace(/&(amp|lt|gt|#34|#39);/g, m => unescapeMap[m])
})
engine.registerFilter('json', function(str) {
  return JSON.stringify(str)
})
engine.registerFilter('present', function(str) {
  return !!str
})
engine.registerFilter('not', function(str) {
  return !str
})
engine.registerFilter('number', function(str, places = 2) {
  return (+str).toFixed(+places).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace(".", ',')
})
engine.registerTag('list', {
  render: function(scope, hash) {
    return Promise.resolve('<ul>')
  }
});
engine.registerTag('endlist', {
  render: function(scope, hash) {
    return Promise.resolve('</ul>')
  }
});
engine.registerTag('item', {
  render: function(scope, hash) {
    return Promise.resolve('<li>')
  }
});
engine.registerTag('enditem', {
  render: function(scope, hash) {
    return Promise.resolve('</li>')
  }
});
engine.registerTag('b', {
  render: function(scope, hash) {
    return Promise.resolve('<strong>')
  }
});
engine.registerTag('endb', {
  render: function(scope, hash) {
    return Promise.resolve('</strong>')
  }
});
engine.registerTag('div', {
  render: function(scope, hash) {
    return Promise.resolve('<div>')
  }
});
engine.registerTag('enddiv', {
  render: function(scope, hash) {
    return Promise.resolve('</div>')
  }
});
engine.registerTag('flex', {
  render: function(scope, hash) {
    return Promise.resolve('<div class="flex-container">')
  }
});
engine.registerTag('endflex', {
  render: function(scope, hash) {
    return Promise.resolve('</div>')
  }
});
engine.registerTag('i', {
  render: function(scope, hash) {
    return Promise.resolve('<em>')
  }
});
engine.registerTag('endi', {
  render: function(scope, hash) {
    return Promise.resolve('</em>')
  }
});
engine.registerTag('s', {
  render: function(scope, hash) {
    return Promise.resolve('<del>')
  }
});
engine.registerTag('ends', {
  render: function(scope, hash) {
    return Promise.resolve('</del>')
  }
});
engine.registerTag('empty', {
  render: function(scope, hash) {
    return Promise.resolve('')
  }
});
engine.registerTag('nbsp', {
  render: function(scope, hash) {
    return Promise.resolve('&nbsp;')
  }
});
engine.registerTag('space', {
  render: function(scope, hash) {
    return Promise.resolve(' ')
  }
});
engine.registerTag('newline', {
  render: function(scope, hash) {
    return Promise.resolve('\n')
  }
});
engine.registerTag('br', {
  render: function(scope, hash) {
    return Promise.resolve('<br>')
  }
});
engine.registerTag('tdspv', {
  render: function(scope, hash) {
    return Promise.resolve('<td class="spvrechnung" align=center>')
  }
});
engine.registerTag('endtdspv', {
  render: function(scope, hash) {
    return Promise.resolve('</td>')
  }
});
engine.registerTag('tablespv', {
  render: function(scope, hash) {
    return Promise.resolve('<table class="spvrechnung" style="width: 100%">')
  }
});
engine.registerTag('endtablespv', {
  render: function(scope, hash) {
    return Promise.resolve('</table>')
  }
});
engine.registerTag('trspv', {
  render: function(scope, hash) {
    return Promise.resolve('<tr class="spvrechnung">')
  }
});
engine.registerTag('endtrspv', {
  render: function(scope, hash) {
    return Promise.resolve('</tr>')
  }
});
engine.registerTag('thspv', {
  render: function(scope, hash) {
    return Promise.resolve('<th class="spvrechnung">')
  }
});
engine.registerTag('endthspv', {
  render: function(scope, hash) {
    return Promise.resolve('</th>')
  }
});

const style = `
  .druck-vorlage-multi-text::before {
    content: "";
    display: block;
    float: left;
    height: var(--druck-vorlage-multi-text-top);
  }
  .druck-vorlage--preview .druck-vorlage-multi-text::after {
    height: calc(0mm + var(--druck-vorlage-multi-text-height));
  }
  .druck-vorlage-multi-text::after {
    content: "";
    display: block;
    float: left;
    clear: left;
    height: var(--druck-vorlage-multi-text-height);
    width: 100%;
  }
  .druck-vorlage__page:nth-child(1) {
    z-index: 5;
  }
  .druck-vorlage__page:nth-child(2) {
    z-index: 4;
  }
  .druck-vorlage__page:nth-child(3) {
    z-index: 3;
  }
  .druck-vorlage__page:nth-child(4) {
    z-index: 2;
  }
  .druck-vorlage__page:nth-child(5) {
    z-index: 1;
  }
  .druck-vorlage__page {
    position: relative;
    box-sizing: border-box;
    font-family: Arial, 'Liberation Sans', 'DejaVu Sans', serif !important;
    line-height: 1.25 !important;
    letter-spacing: 0.01em !important;
    font-weight: 400 !important;
    text-rendering: optimizeLegibility !important;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    // margin-bottom: -0.2mm;
    // overflow: hidden;
  }

  .druck-vorlage--preview .druck-vorlage__page::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: white;
    opacity: 0;
    pointer-events: none;
  }
  .druck-vorlage--opacity-0 .druck-vorlage__page::before {
    opacity: 1;
  }
  .druck-vorlage--opacity-1 .druck-vorlage__page::before {
    opacity: 0.8;
  }
  .druck-vorlage--opacity-2 .druck-vorlage__page::before {
    opacity: 0.7;
  }
  .druck-vorlage--opacity-2 .druck-vorlage__page::before {
    opacity: 0.4;
  }

  .druck-vorlage__page strong {
    line-height: inherit !important;
    letter-spacing: inherit !important;
    font-size: inherit !important;
  }
  .druck-vorlage__page ul {
    padding: 0.25em 0 0.25em 1.25em !important;
    margin: 0 !important;
  }
  .druck-vorlage__page li {
    margin: 0; !important;
    padding: 0; !important;
  }

  .druck-vorlage--preview .druck-vorlage__page {
    margin: 0mm auto;
    box-shadow: 0 0 1mm 1mm rgba(0,0,0, 0.2);
    overflow: visible;
  }

  .druck-vorlage__page__text {
    position: absolute;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .druck-vorlage--preview .druck-vorlage__page__text {
    background-color: rgba(80, 80, 80, 0.15)
  }
  .druck-vorlage--preview .druck-vorlage__page__text:before {
    border: 1px solid rgba(0,0,0,0.1);
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
  }
  .druck-vorlage--noborder .druck-vorlage__page__text:before {
    display: none;
  }
  .druck-vorlage--noborder .druck-vorlage__page__text {
    background-color: transparent;
  }
  .druck-vorlage__page__text.align-left {
    text-align: left;
  }
  .druck-vorlage__page__text.align-right {
    text-align: right;
  }
  .druck-vorlage__page__text.align-center {
    text-align: center;
  }
  .druck-vorlage__page__text.align-justify {
    text-align: justify;
    white-space: pre-line;
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .flex-container div{
    flex-shrink: 1;
    flex-grow: 1;
  }
  .flex-containter div:nth-child(2){
    padding-left: 1em;
    padding-right: 1em;
  }
  .spvrechnung{
    border: 1px solid black;
    border-collapse: collapse;
  }
`

export default {
  props: {
    druckvorlagenName: String,
    value: Object,
    item: Object,
    editing: Boolean,
    bg: {
      type: Number,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    bezeugung: {
      type: Boolean,
    },
    pdfNichtSpeichern: {
      type: Boolean,
    },
    url2pdfHost: String,
    anzahl: {
      type: Number,
      default: 1
    },
    color: String,
    noEditor: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ExtraDruckVorlagenPage
  },
  data() {
    return {
      showInfo: false,
      html: null,
      edit: null,
      currentPage: null,
      editorContent: "",
      pages: [],
      error: null,
      resizing: null,
      resizePage: null,
      hideBg: false,
      hideBorder: false,
      pageWidth: 21.0,
      pageHeight: 29.7,
      lang: {
        bold: 'Bold'
      },
      pageSizes: [
        { text: 'A4', value: 'A4', width: 210, height: 297 },
        { text: 'A5', value: 'A5', width: 148, height: 210 },
        { text: 'A6', value: 'A6', width: 105, height: 148 },
        { text: 'ViKa', value: 'ViKa', width: 85, height: 55 }
      ]
    }
  },
  mounted() {
    const styleEl = document.createElement('style')
    styleEl.innerHTML = style
    this.$el.appendChild(styleEl)
    if (!this.editing) {
      this.$emit('ready2print', this, 'A4')
    }
  },
  apollo: {
    currentUser: {
      query: gql`query ExtradruckVorlagenSettingsVueCurrentUser {
        currentUser {
          id
          vorname
          nachname
          druckStandorte {
            id
            standard
            name
            bezeugungsSignatur
            bezeugungsOrt
            druckToken
            druckOptionen {
              id
              druckVorlageId
              drucker
              einzug
              duplex
              farbe
              orientierung
            }
          }
        }
      }`
    },
    patientenverfuegungen: {
      query: gql`query ExtraDruckVorlagenVue {
        patientenverfuegungen {
          id
          status
          vorname
          nachname
          dringlichkeit
          betrag
          data
        }
      }`,
      fetchPolocy: 'network-only',
    },
    patientenverfuegungPdfs: {
      query: gql`query ExtraDruckVorlagenVuePdf($id: ID){
        patientenverfuegungPdfs(where: { patientenverfuegungId: $id }) {
          id
          pdfUrl
          patientenverfuegungId
          createdAt
          druckvorlagenName
          texte {
            text
            name
            size
          }
        }
      }`,
      variables() {
          return { id: this.item.id }
      },
      skip() {
        return !this.item || !this.item.id
      },
    }
  },
  watch: {
    item(item) {
      this.resizing = null
      this.resizePage = null
      this.renderTemplates(this.value, item)
    },
    value: {
      immediate: true,
      handler(value) {
        this.renderTemplates(value, this.item)
      }
    },
    bezeugung() {
      this.renderTemplates(this.value, this.item)
    }
  },
  computed: {
    itemData() {
      const item = this.item
      if (item) {
        return JSON.parse(item.data)
      }
    },
    showBg() {
      return this.hideBg ? false : !!this.bg
    },
    showBorder() {
      return this.hideBorder ? false : this.border
    },
    bgOpacity() {
      const bg = this.bg
      if (bg <= 0) {
        return 0
      } else if (bg >= 3) {
        return 3
      } else {
        return bg
      }
    },
    minWidth() {
      if (this.value && this.value.pages.length) {
        return maxBy(this.value.pages, 'width').width
      } else {
        return 0
      }
    }
  },
  methods: {
    getTexts() {
      return this.pages.map((page) => {
        return page.texts.map((text, i) => {
          return {
            text: text.text,
            name: i.toString(),
            size: text.size
          }
        })
      })
    },
    showOldText(patientenverfuegungPdf){
      this.daysBetween(patientenverfuegungPdf.createdAt)
      this.pages.forEach((page,i) => {
        page.texts.forEach((text, j) => {
          text.text = patientenverfuegungPdf.texte[i][j]["text"]
          text.size = patientenverfuegungPdf.texte[i][j]["size"]
        })
      })
    },
    pdfDestroy(id){
      this.$apollo.mutate({
        mutation: gql`mutation (
          $id: ID!
        ) {
          patientenverfuegungPdfDestroy (id: $id){
            success
          }
        }`,
        variables: {
          id
        },
       }).then((response) => {
        if (response) {
          this.$apollo.queries.patientenverfuegungPdfs.refetch()
        } else {
          alert('Ein Fehler is aufgetreten.')
        }
      })
    },
    formatDate(date) {
      return moment(date).format("LLLL")
    },
    daysBetween(date){
      return moment().diff(date, 'days')
    },
    async print(options) {
      return new Promise((resolve, reject) => {
        this.hideBg = true
        this.$nextTick(async () => {
          try {
            let html = this.$refs.pages.innerHTML
            this.hideBg = false
            const page = this.pages[0]
            const size = { width: `${page.width}mm`, height: `${page.height}mm` }
            const styleEl = `<style>
              @page { size: ${size.width} ${size.height}; } html, body { min-height: 100%; margin: 0; padding: 0; }
              :root {
                --druck-vorlage-multi-text-top: ${document.documentElement.style.getPropertyValue('--druck-vorlage-multi-text-top')};
                --druck-vorlage-multi-text-height: ${document.documentElement.style.getPropertyValue('--druck-vorlage-multi-text-height')};
              }
              ${style}
              </style>`
            html = `<!DOCTYPE html><html><head><meta charset="utf-8"/>${styleEl}</head><body class="print-pages">${html}</body></html>`
            if (options && options.downloadPdf && options.ctrlKey) {
              const w = window.open()
              w.document.open().write(html)
              w.document.close()
              resolve({ html: html })
            } else {
              if (!this.url2pdfHost) {
                throw 'url2pdfHost not set'
              }
              const resp = await this.$http.post(`${this.url2pdfHost}/api/render`, { html: html, pdf: size }, { responseType: 'blob', headers: { "Content-Type": "application/json" } })
              const blob = await resp.blob()
              const fileURL = URL.createObjectURL(blob)
              if (options.downloadPdf || options.ctrlKey) {
                window.open(fileURL)
                var reader = new FileReader()
                reader.readAsDataURL(blob)
                reader.onloadend = () => {
                  var base64data = reader.result
                  this.savePdf(base64data, this.getTexts())
                }
              } else {
                await printPdfFor(blob, this.currentUser, this.value, this.anzahl)
              }
              resolve({ html: html, pdf: fileURL })
            }
          } catch(error) {
            reject(error)
          }
        })
      })
    },
    async renderTemplates(value, item) {
      this.showInfo = false
      this.error = null
      if (item) {
        const data = item.data ? JSON.parse(item.data) : {}
        Object.assign(data, item)
        data.heute = moment().format('DD.MM.Y')
        if (this.bezeugung) {
          const druckOptionen = druckOptionenFor(this.currentUser)
          if (druckOptionen && druckOptionen.bezeugung) {
            data.bezeugung_name = druckOptionen.bezeugung.signatur
            data.bezeugung_ort = druckOptionen.bezeugung.ort
          }
          data.bezeugung_datum = data.heute
        }
        const innerData = {}
        Object.assign(innerData, data)
        delete innerData.raw
        delete innerData.data
        data.data = innerData
        try {
          this.pages = []
          const renders = []
          value.pages.forEach(page => {
            page.texts.map(text => {
              renders.push(engine.parseAndRender(text.template, data).then(rendered => {
                let txt = rendered.replace(/<ul>\s*<\/ul>/g, '').replace(/¬/g, '&shy;').replace(/^\s+/, '')
                if (/-%}\s*$/.test(text.template)) {
                  txt = txt.replace(/\s+$/, '')
                }
                text.text = txt
              }))
            })
          })
          await Promise.all(renders)
          this.$nextTick(() => {
            this.pages = value.pages
            this.$nextTick(() => {
              this.resizeTexts()
            })
          })
        } catch (error) {
          this.error = `Fehler Im Template: ${error ? error.message || '' : ''}`
          console.error(error)
        }
      } else {
        this.pages = value.pages
      }
    },
    async resizeTexts() {
      let textI = -1
      const multipleTexts = []
      const item = !!this.item
      let minSize = 9999
      let minLineHeight = 9999
      this.pages.forEach(page => {
        page.texts.forEach(text => {
          textI += 1
          if (item && text.options.indexOf('multiple-text') >= 0) {
            multipleTexts.push([text, textI])
          } else if (item || (text !== this.resizing)) {
            this.resizeText(text, this.$refs.textWraps[textI])
            if (text.size < minSize || (text.size === minSize && text.lineHeight < minLineHeight)) {
              minSize = text.size
              minLineHeight = text.lineHeight
            }
          } else {
            text.size = 3.5
            text.lineHeight = 1.05
          }
        })
      })
      if (multipleTexts.length === 2 && multipleTexts[0][0].text && !multipleTexts[1][0].text) {
        let totalHeight = multipleTexts.map(([text]) => text.height).reduce((h,a) => a+h, 0)
        const [firstText, firstI] = multipleTexts[0]
        const [secondText, secondI] = multipleTexts[1]
        const firstEl = this.$refs.textWraps[firstI]
        const space = this.pages[0].height - firstText.y - firstText.height + secondText.y
        firstEl.parentNode.style.height = `${totalHeight + space}mm`
        document.documentElement.style.setProperty('--druck-vorlage-multi-text-top', `${firstText.height}mm`)
        document.documentElement.style.setProperty('--druck-vorlage-multi-text-height', `${space}mm`)
        this.resizeText(firstText, firstEl)
        if (firstText.size < minSize || (firstText.size === minSize && firstText.lineHeight < minLineHeight)) {
          minSize = firstText.size
          minLineHeight = firstText.lineHeight
        }
        firstEl.parentNode.style.height = `${firstText.height}mm`
      } else {
        document.documentElement.style.setProperty('--druck-vorlage-multi-text-top', 0)
        document.documentElement.style.setProperty('--druck-vorlage-multi-text-height', 0)
        let smallest = { size: 9999, lineHeight: 9999 }
        multipleTexts.forEach(([text, textI]) => {
          this.resizeText(text, this.$refs.textWraps[textI])
          if (text.size < smallest.size || (text.size === smallest.size && text.lineHeight < smallest.lineHeight)) {
            smallest = text
          }
          if (text.size < minSize || (text.size === minSize && text.lineHeight < minLineHeight)) {
            minSize = text.size
            minLineHeight = text.lineHeight
          }
        })
        multipleTexts.forEach(([text, textI]) => {
          text.size = smallest.size
          text.lineHeight = smallest.lineHeight
        })
      }
      this.pages.forEach(page => {
        page.texts.forEach(text => {
          if (!item || text.options.indexOf('multiple-text') < 0) {
            text.size = minSize
            text.lineHeight = minLineHeight
          }
        })
      })
    },
    savePdf(pdfUrl, texte) {
      if (this.pdfNichtSpeichern === false){
        this.$apollo.mutate({
          mutation: gql`mutation (
              $pdfUrl: String
              $patientenverfuegungId: ID
              $texte: [[PatientenverfuegungTextInput]]
              $druckvorlagenName: String
          ) {
            patientenverfuegungPdfCreate(pdfUrl: $pdfUrl, patientenverfuegungId: $patientenverfuegungId, texte: $texte, druckvorlagenName: $druckvorlagenName){
              id
              pdfUrl
              patientenverfuegungId
              druckvorlagenName
            }
          }`,
          variables: {
            pdfUrl,
            texte,
            patientenverfuegungId: this.item.id,
            druckvorlagenName: this.druckvorlagenName
          },
        }).then((response) => {
          if (response) {
            this.$apollo.queries.patientenverfuegungPdfs.refetch()
          } else {
            alert('Ein Fehler is aufgetreten.')
          }
        })
      }
    },
    clickOutside() {
      this.resizing = false
      this.resizePage = null
    },
    trixInitialize(event, pageIndex) {
      this.currentPage = pageIndex
    },
    trixChange(event, text) {
      if (this.item) {
        text.text = this.$refs.trixi.value
      } else {
        text.template = this.$refs.trixi.value
      }
    },
    handleContentChange(event, text) {
      text.text = this.$refs.trixi[0].value
    },
    resizeBigger() {
      if (this.resizing) {
        this.resizing.size *= 1.01
      }
    },
    resizeSmaller() {
      if (this.resizing) {
        this.resizing.size *= 1/1.01
      }
    },
    changeFormat(format, page) {
      const isLandscape = page.width > page.height
      const pageFormat = this.pageSizes.find(f => f.value === format) || this.pageSizes[0]
      page.width = pageFormat.width
      page.height = pageFormat.height
      this.changeLandscape(isLandscape, page)
    },
    changeLandscape(landscape, page) {
      const isLandscape = page.width > page.height
      if (landscape != isLandscape) {
        const newHeight = page.width
        page.width = page.height
        page.height = newHeight
      }
    },
    removeBackground(page) {
      if (window.confirm("Hintergrund entfernen?")) {
        page.backgroundUrl = null
        page.backgroundName = null
      }
    },
    changeBackground(base64, page) {
      page.backgroundUrl = base64
    },
    movePageDown(page) {
      const index = this.value.pages.indexOf(page)
      if (index >= 0) {
        this.value.pages.splice(index, 1)
        this.value.pages.splice(index + 1, 0, page)
      }
    },
    movePageUp(page) {
      const index = this.value.pages.indexOf(page)
      if (index >= 0) {
        this.value.pages.splice(index, 1)
        this.value.pages.unshift(page)
      }
    },
    deletePage(page) {
      const index = this.value.pages.indexOf(page)
      if (index >= 0 && window.confirm("wirklich löschen?")) {
        this.value.pages.splice(index, 1)
      }
    },
    clickPage(event, page) {
      this.resizing = null
      this.resizePage = null
    },
    clickText(event, page, text) {
      event.stopPropagation()
      if (this.noEditor) {
        return
      }
      if (this.resizing !== text) {
        if (this.item) {
          this.editorContent = text.text || ''
        } else {
          this.editorContent = text.template || ''
        }
        this.$nextTick(() => {
          this.resizePage = page
          this.resizing = text
          // this.focusText('move')
          this.$nextTick(() => {
            this.$refs.trix && this.$refs.trix[0] && this.$refs.trix[0].focus()
          })
        })
      }
    },
    focusText(action) {
      this.$nextTick(() => {
        if (this.$refs[action] && this.$refs[action][0]) {
          this.$refs[action][0].focus()
        }
      })
    },
    keyText(event, page, text, action) {
      event.preventDefault()
      if (event.shiftKey) {
        this.showInfo = true
        if (action === 'up' && event.key === 'ArrowDown' ||
            action === 'down' && event.key === 'ArrowUp' ||
            action === 'left' && event.key === 'ArrowRight' ||
            action === 'right' && event.key === 'ArrowLeft') {
          this.focusText('move')
        } else {
          if (/^Arrow/.test(event.key)) {
            this.focusText(event.key.replace(/Arrow/,'').toLowerCase())
          }
        }
        return
      }
      let step = 1
      if (event.ctrlKey) {
        step = 10
      } else if (event.altKey) {
        step = 0.1
      }
      if (action === 'move') {
        if (event.key === 'ArrowDown') {
          text.y += step
          if (text.y + text.height > page.height) {
            text.y = page.height - text.height
          }
        } else if (event.key === 'ArrowUp') {
          text.y -= step
          if (text.y < 0) {
            text.y = 0
          }
        } else if (event.key === 'ArrowRight') {
          text.x += step
          if (text.x + text.width > page.width) {
            text.x = page.width - text.width
          }
        } else if (event.key === 'ArrowLeft') {
          text.x -= step
          if (text.x < 0) {
            text.x = 0
          }
        }
      } else if (action === 'right') {
        if (event.key === 'ArrowRight') {
          text.width += step
          if (text.x + text.width > page.width) {
            text.width = page.width - text.x
          }
        } else if (event.key === 'ArrowLeft') {
          text.width -= step
          if (text.width < 1) {
            text.width = 1
          }
        }
      } else if (action === 'left') {
        if (event.key === 'ArrowRight') {
          text.width -= step
          text.x += step
          if (text.width < 1) {
            text.x += text.width - 1
            text.width = 1
          }
        } else if (event.key === 'ArrowLeft') {
          text.width += step
          text.x -= step
          if (text.x < 0) {
            text.width += text.x
            text.x = 0
          }
        }
      } else if (action === 'down') {
        if (event.key === 'ArrowDown') {
          text.height += step
          if (text.y + text.height > page.height) {
            text.height = page.height - text.y
          }
        } else if (event.key === 'ArrowUp') {
          text.height -= step
          if (text.height < 1) {
            text.height = 1
          }
        }
      } else if (action === 'up') {
        if (event.key === 'ArrowDown') {
          text.height -= step
          text.y += step
          if (text.height < 1) {
            text.y += text.height - 1
            text.height = 1
          }
        } else if (event.key === 'ArrowUp') {
          text.height += step
          text.y -= step
          if (text.y < 0) {
            text.height += text.y
            text.y = 0
          }
        }
      }
    },
    removeText(page, text) {
      if (confirm('Text wirklich löschen?')) {
        const i = page.texts.indexOf(text)
        if (i >= 0) {
          page.texts.splice(i, 1)
        }
      }
    },
    addText(page) {
      page.texts.push({
        x: 10,
        y: 10,
        width: 50,
        height: 8 * 1.25,
        size: 8,
        lineHeight: 1.05,
        type: "text",
        template: "",
        text: "",
        options: [],
      })
    },
    align(alignment) {
      if (this.resizing) {
        const options = this.resizing.options.filter(opt => !/^align-/.test(opt))
        const name = `align-${alignment}`
        const add = this.resizing.options.indexOf(name) < 0
        if (add) {
          options.push(name)
        }
        this.resizing.options = options
      }
    },
    textOption(name) {
      const options = this.resizing.options.filter(opt => opt !== name)
      const old = this.resizing.options.indexOf(name) >= 0
      if (!old) {
        options.push(name)
      }
      this.resizing.options = options
    },
    resizeText(text, el) {
      const { size, lineHeight } = this.resizeTextMultiline(el)
      text.size = size
      text.lineHeight = lineHeight
    },
    resizeTextMultiline(el) {
      const maxHeight = el.parentNode.getBoundingClientRect().height
      el.style.lineHeight = 1.05
      el.style.height = 'auto'
      const size = this.resizeTextMultilineStep(el, maxHeight, 1, 30, 6)
      const lineHeight = this.resizeTextMultilineStepLH(el, maxHeight, 1, 1.5, 6)
      el.style.height = null
      el.style.lineHeight = null
      el.style.fontSize = null
      return { size, lineHeight }
    },
    resizeTextMultilineStep(el, maxHeight, minSize, maxSize, depth) {
      if (depth <= 0) {
        el.style.fontSize = `${minSize}mm`
        return minSize
      }
      const pivot = minSize + (maxSize - minSize) / 2
      el.style.fontSize = `${pivot}mm`
      const height = el.getBoundingClientRect().height
      if (height >= maxHeight) {
        return this.resizeTextMultilineStep(el, maxHeight, minSize, pivot, depth - 1)
      } else {
        return this.resizeTextMultilineStep(el, maxHeight, pivot, maxSize, depth - 1)
      }
    },
    resizeTextMultilineStepLH(el, maxHeight, minSize, maxSize, depth) {
      if (depth <= 0) {
        el.style.lineHeight = minSize
        return minSize
      }
      const pivot = minSize + (maxSize - minSize) / 2
      el.style.lineHeight = pivot
      const height = el.getBoundingClientRect().height
      if (height > maxHeight) {
        return this.resizeTextMultilineStepLH(el, maxHeight, minSize, pivot, depth - 1)
      } else {
        return this.resizeTextMultilineStepLH(el, maxHeight, pivot, maxSize, depth - 1)
      }
    },
    splitMultitext() {
      const texts = []
      let textI = -1
      this.pages.forEach(page => {
        page.texts.forEach(text => {
          textI++
          if (text.options.indexOf('multiple-text') >= 0) {
            texts.push([text, textI])
          }
        })
      })
      const editor = window.e = this.$refs.trix[0].editor
      const pos = editor.getSelectedRange()[0]

      if (!this.item || texts.length !== 2) {
        return
      } else if (texts[1][0].text) {
        this.resizing = false
        this.resizePage = null
        texts[0][0].text += texts[1][0].text
        texts[1][0].text = ''
      } else if (pos !== 0 && this.resizing === texts[0][0]) {
        editor.recordUndoEntry('split multi page text')
        editor.setSelectedRange([0, pos])
        editor.deleteInDirection("forward")
        const first = editor.element.innerHTML
        editor.undo()
        editor.recordUndoEntry('split multi page text')
        editor.setSelectedRange([pos, 9999999999])
        editor.deleteInDirection("forward")
        texts[1][0].text = first
        this.resizing = false
        this.resizePage = null
      }
      this.$nextTick(() => {
        this.resizeTexts()
      })
    }
  },
}
</script>
